<app-admin-wa-inbox *ngIf="waService.waConversation.length === 0">

</app-admin-wa-inbox>

<app-admin-wa-conversation *ngIf="waService.waConversation.length >= 1">
</app-admin-wa-conversation>
